import React from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import MyAccountOrderDetails from './MyAccountOrderDetails';
import CarePlusOrderDetail from '../CarePlusOrderDetail/CarePlusOrderDetail';

const MyAccountOrderDetailsDispatcher: React.FC = () => {
  const { order_hash_id } = useParams<{ order_hash_id: string }>();
  const { asideBarData } = useOutletContext<any>();

  if (asideBarData?.carePlusSubscriptionHashId && (
    order_hash_id === asideBarData.carePlusSubscriptionHashId ||
    asideBarData.carePlusOrderHashIds?.includes(order_hash_id!)
  )) {
    return <CarePlusOrderDetail />;
  }

  return <MyAccountOrderDetails />;
};

export default MyAccountOrderDetailsDispatcher;
